<template>
  <div>
      <div >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="执照全称" prop="partner_name">
                    <el-input v-model="ruleForm.partner_name" placeholder="请输入执照全称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="执照简称" prop="partner_abbreviation">
                    <el-input v-model="ruleForm.partner_abbreviation" placeholder="请输入执照简称"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="开户行" prop="opening_bank">
                    <el-input v-model="ruleForm.opening_bank" placeholder="请输入开户行"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开户行账号" prop="bank_account">
                    <el-input v-model="ruleForm.bank_account" placeholder="请输入开户行账号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="经营地址" prop="partner_address">
                    <el-input v-model="ruleForm.partner_address" placeholder="请输入经营地址"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话" prop="partner_contact">
                    <el-input v-model="ruleForm.partner_contact" placeholder="请输入联系电话"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="法定代表人" prop="partner_represent">
                    <el-input v-model="ruleForm.partner_represent" placeholder="请输入法定代表人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="注册地址" prop="register_address">
                    <el-input v-model="ruleForm.register_address" placeholder="请输入注册地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="执照代码" prop="partner_code">
                    <el-input v-model="ruleForm.partner_code" placeholder="请输入执照代码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="简称编码" prop="abbreviation_code">
                    <el-input v-model="ruleForm.abbreviation_code" placeholder="请输入简称编码"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="税率" prop="tax_rate">
                    <el-input v-model="ruleForm.tax_rate" placeholder="请输入税率"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                    <el-form-item label="营业期限" required>
                    <el-col :span="10">
                    <el-form-item prop="date1">
                        <el-date-picker type="date" placeholder="请选择" v-model="ruleForm.date1" style="width:85%"></el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1"> - </el-col>
                    <el-col :span="10">
                    <el-form-item prop="date1">
                        <el-date-picker type="date" placeholder="请选择" v-model="ruleForm.date2" style="width:85%"></el-date-picker>
                    </el-form-item>
                    </el-col>
                </el-form-item>
                </el-col>
                </el-row>

                <el-row>
                <el-col :span="12">
                    <el-radio v-model="radio" label="1">长期</el-radio>
                </el-col>
                </el-row>
                
            </div>

            <el-form-item style="margin-left:250px">
                <el-button type="goon" @click="submitForm('ruleForm')" 
                      v-show="ruleForm.id == null || ruleForm.id == ''">保存</el-button>
                <el-button type="goon" @click="submitFormupdate('ruleForm')" 
                      v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
                <el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
            </el-form>
      </div>

  </div>
</template>

<script>
export default {
   data() {
      return {
        ruleForm: {
          partner_name:"",
          opening_bank:"",
          bank_account:"",
          partner_address:"",
          partner_contact:"",
          partner_represent:"",
          partner_abbreviation:"",
          register_addres:"",
          partner_code:"",
          abbreviation_code:"",
          register_address:"",
          tax_rate:"",
        },
        rules: {
          partner_name: [
            { required: true, message: '请输入执照全称', trigger: 'blur' },
          ],
          opening_bank: [
            { required: true, message: '请输入开户行', trigger: 'blur' },
          ],
          bank_account: [
            { required: true, message: '请输入开户行账号', trigger: 'blur' },
          ],
          partner_address: [
            { required: true, message: '请输入经营地址', trigger: 'blur' },
          ],
          partner_contact: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
          ],
          partner_represent: [
            { required: true, message: '请输入法人代表', trigger: 'blur' },
          ],
          partner_abbreviation: [
            { required: true, message: '请输入执照简称', trigger: 'blur' },
          ],
          register_address: [
            { required: true, message: '请输入注册地址', trigger: 'blur' },
          ],
          partner_code: [
            { required: true, message: '请输入执照代码', trigger: 'blur' },
          ],
          abbreviation_code: [
            { required: true, message: '请输入简称编码', trigger: 'blur' },
          ],
          tax_rate: [
            { required: true, message: '请输入税率', trigger: 'blur' },
          ],
        }
      };
    },
    props:["ruleForm"],
    methods: {
      submitForm(ruleForm) {
        this.$refs[ruleForm].validate(async(valid) => {
          if (valid) {
            var url = "partner/insert";
            var record = {
              data_name: "合同名头管理-新增",
              data_grouping: "jfmtgl_add",
              partner_name: this.ruleForm.partner_name,
              opening_bank:this.ruleForm.opening_bank,
              bank_account:this.ruleForm.bank_account,
              partner_address:this.ruleForm.partner_address,
              partner_contact:this.ruleForm.partner_contact,
              partner_represent:this.ruleForm.partner_represent,
              partner_abbreviation:this.ruleForm.partner_abbreviation,
              register_address:this.ruleForm.register_address,
              partner_code:this.ruleForm.partner_code,
              abbreviation_code:this.ruleForm.abbreviation_code,
              tax_rate:this.ruleForm.tax_rate,
            };
            var data = await this.$globals.AxiosPost(url, record);
              if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
              } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                  this.$message.success(data);
                  this.$parent.$parent.dialogVisible = false
                  this.$parent.$parent.trash();
                  this.$parent.$parent.Find();
                } else {
                  this.$message.warning(data);
                }
              }
          }
        });
      },
      // 编辑
      submitFormupdate(ruleForm){
        this.$refs[ruleForm].validate(async (valid) => {
            if (valid) {
                var url = "partner/upDatePartner";
                var record = {
                    id: this.ruleForm.id,
                    data_name: "合同名头管理-编辑",
                    data_grouping: "jfmtgl_edit",
                    partner_name: this.ruleForm.partner_name,
                    opening_bank:this.ruleForm.opening_bank,
                    bank_account:this.ruleForm.bank_account,
                    partner_address:this.ruleForm.partner_address,
                    partner_contact:this.ruleForm.partner_contact,
                    partner_represent:this.ruleForm.partner_represent,
                    partner_abbreviation:this.ruleForm.partner_abbreviation,
                    register_address:this.ruleForm.register_address,
                    partner_code:this.ruleForm.partner_code,
                    abbreviation_code:this.ruleForm.abbreviation_code,
                    tax_rate:this.ruleForm.tax_rate,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.$parent.$parent.dialogVisible = false
                        this.$parent.$parent.trash();
                        this.$parent.$parent.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            }
        });
      },
      resetForm(ruleForm) {
        this.$refs[ruleForm].resetFields();
      },
    }
}
</script>

<style>
.el-checkbox__input.is-checked+.el-checkbox__label{
    color: #006E4B;
}
.el-input{
    width: 80%;
}

</style>


// WEBPACK FOOTER //
// Jfmtgl_add.vue?60f54286